import PropTypes from 'prop-types';
import _ from 'underscore';
import React from 'react';
import { PrimaryButton, DefaultButton, Dialog, DialogType, DialogFooter } from '@fluentui/react';

export const DialogTexts = {
  Title: _TL_('Disabling Microsoft Clarity may impact your custom-event conversions'),
  Body: _TL_('Disabling Microsoft Clarity for this UET tag will deactivate any associated conversion goals that were setup using the "Code-free with Clarity" method. You will stop receiving conversions data for those goals.'),
  Primary: _TL_('Disable anyway'),
  Secondary: _TL_('Cancel'),
};

function DialogContent(props) {
  const {
    primaryButtonCallback,
    secondaryButtonCallback,
    i18n,
  } = props;

  const titleText = i18n.getString(DialogTexts.Title);
  const bodyText = i18n.getString(DialogTexts.Body);
  const primaryText = i18n.getString(DialogTexts.Primary);
  const secondaryText = i18n.getString(DialogTexts.Secondary);

  return (
    <div className="clarity-warning-dialog-content">
      <div className="title">
        <h3>{titleText}</h3>
      </div>
      <div className="ms-Dialog-header">
        {bodyText}
      </div>
      <DialogFooter>
        <PrimaryButton
          id="clarity-warning-dialog-confirm"
          onClick={primaryButtonCallback}
          text={primaryText}
        />
        <DefaultButton
          id="clarity-warning-dialog-cancel"
          onClick={secondaryButtonCallback}
          text={secondaryText}
        />
      </DialogFooter>
    </div>
  );
}

DialogContent.defaultProps = {
  primaryButtonCallback: _.noop,
  secondaryButtonCallback: _.noop,
};
DialogContent.propTypes = {
  primaryButtonCallback: PropTypes.func,
  secondaryButtonCallback: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

// a blocking non-draggable fabric dialog to confirm user choice for not including conversion dialog
export function ClarityUncheckWarningDialog(props) {
  const {
    i18n,
    shouldShowDialog,
    checkIncludeCallback,
    uncheckIncludeCallback,
  } = props;

  return (
    <Dialog
      hidden={!shouldShowDialog}
      onDismiss={uncheckIncludeCallback}
      dialogContentProps={{
        type: DialogType.close, // with x close button in the upper-right corner
      }}
      maxWidth={460}
      minWidth={460}
      modalProps={{
        isBlocking: true,
        dragOptions: undefined, // non-dragable
      }}
    >
      <DialogContent
        primaryButtonCallback={checkIncludeCallback}
        secondaryButtonCallback={uncheckIncludeCallback}
        i18n={i18n}
      />
    </Dialog>
  );
}

ClarityUncheckWarningDialog.defaultProps = {
  shouldShowDialog: false,
  checkIncludeCallback: _.noop,
  uncheckIncludeCallback: _.noop,
};
ClarityUncheckWarningDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  shouldShowDialog: PropTypes.bool,
  checkIncludeCallback: PropTypes.func,
  uncheckIncludeCallback: PropTypes.func,
};

